/** Material UI Packages. */
import { Stack, Switch, Chip, IconButton, Box } from '@mui/material';

/** Material UI Icons. */
import DeleteIcon from '@mui/icons-material/Delete';

export const addOnsCol = (handleStatusToggle, handleDeleteAddOn) => [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: 'Add-on Name', flex: 1, editable: true },
    {
        field: 'status',
        headerName: 'Status',
        width: 140,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
            <Stack direction="row" alignItems="center" spacing={1}>
                <Switch
                    checked={params.row.status}
                    onChange={() => handleStatusToggle(params.row.id)}
                    color="primary"
                />
                <Chip
                    label={params.row.status ? 'Active' : 'Inactive'}
                    color={params.row.status ? 'success' : 'default'}
                    size="small"
                    readOnly
                    onClick={(e) => e.stopPropagation()}
                />
            </Stack>
        ),
    },
    {
        field: 'actions',
        headerName: '',
        align: 'center',
        headerAlign: 'center',
        width: 30,
        renderCell: (params) => (
            <Box
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}
            >
                <IconButton size="small" onClick={(event) => handleDeleteAddOn(event, params.id)}>
                    <DeleteIcon />
                </IconButton>
            </Box>
        ),
    },
];
